import React from 'react';
import { Minus, Plus, Trash2, Sprout } from 'lucide-react';

import { useCart } from '../../context/CartContext';
import { formatPrice } from '../../utils/money';
import { cloudinaryThumb, cloudinaryThumbSrcSet } from '../../utils/cloudinary';
import Badge from '../ui/Badge';

// One cart line: photo, title, unit price, qty stepper, line total, remove.
// Handles removed/out-of-stock lines (available === false) gracefully.
export default function CartLineItem({ item }) {
  const { setQuantity, removeItem } = useCart();
  const unavailable = item.available === false;

  return (
    <div className={`ss-cartline ${unavailable ? 'ss-cartline--unavailable' : ''}`}>
      <div className="ss-cartline__media">
        {item.photoUrl ? (
          <img
            src={cloudinaryThumb(item.photoUrl, 100)}
            srcSet={cloudinaryThumbSrcSet(item.photoUrl, 100)}
            alt={item.title}
            loading="lazy"
          />
        ) : (
          <Sprout size={28} aria-hidden="true" />
        )}
      </div>

      <div className="ss-cartline__body">
        <div className="ss-cartline__top">
          <div>
            <div className="ss-cartline__title">
              {item.title}
              {item.depositRequired && <Badge className="ss-deposit-badge">{item.depositPercent}% deposit</Badge>}
              {item.localPickupOnly && <Badge className="ss-pickup-badge">Pickup required</Badge>}
            </div>
            <div className="ss-cartline__unit">{formatPrice(item.unitPrice)} each</div>
          </div>
          <button
            type="button"
            className="ss-cart-remove"
            aria-label={`Remove ${item.title}`}
            onClick={() => removeItem(item.productId)}
          >
            <Trash2 size={18} aria-hidden="true" />
          </button>
        </div>

        {unavailable && <div className="ss-cartline__warn">No longer available</div>}

        <div className="ss-cartline__row">
          <div className="ss-qty" role="group" aria-label={`Quantity for ${item.title}`}>
            <button
              type="button"
              onClick={() => setQuantity(item.productId, item.quantity - 1)}
              aria-label="Decrease quantity"
            >
              <Minus size={14} aria-hidden="true" />
            </button>
            <span>{item.quantity}</span>
            <button
              type="button"
              onClick={() => setQuantity(item.productId, item.quantity + 1)}
              aria-label="Increase quantity"
              disabled={unavailable}
            >
              <Plus size={14} aria-hidden="true" />
            </button>
          </div>
          <span className="ss-price">{formatPrice(item.lineTotal)}</span>
        </div>
      </div>
    </div>
  );
}
